export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    customers: 'Customers',
    invoices: 'Invoices',
    payments: 'Payments',
    settings: 'Settings',
    branches: 'Branches',
    servicePlans: 'Service Plans',
    expenses: 'Expenses',
    reports: 'Financial Reports',
    whatsapp: 'WhatsApp',
    companySettings: 'Company Info',
    users: 'Users',
    owners: 'Owners',
    systemTools: 'System Tools',
    
    // Dashboard
    good: 'Good',
    warning: 'Warning',
    critical: 'Critical',
    other: 'Other',
    totalRevenue: 'Total Revenue',
    fromLastMonth: 'from last month',
    latestCustomers: 'Latest Customers',
    viewAll: 'View All',
    status: 'Status',
    name: 'Name',
    accountNo: 'Account No.',
    plan: 'Plan',
    monthlyFee: 'Monthly Fee',
    connection: 'Connection',
    online: 'Online',
    offline: 'Offline',
    
    // Customers
    customerManagement: 'Customer Management',
    addCustomer: 'Add Customer',
    searchCustomers: 'Search customers...',
    addNewCustomer: 'Add New Customer',
    customer: 'Customer',
    actions: 'Actions',
    email: 'Email',
    phone: 'Phone Number',
    address: 'Address',
    servicePlan: 'Service Plan',
    mikrotikUser: 'Mikrotik Username',
    mikrotikPassword: 'Mikrotik Password',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    activate: 'Activate',
    isolate: 'Isolate',
    
    // Invoices
    invoiceManagement: 'Invoice Management',
    totalInvoices: 'total invoices',
    generateMonthlyInvoices: 'Generate Monthly Invoices',
    invoiceNumber: 'Invoice No.',
    amount: 'Amount',
    dueDate: 'Due Date',
    paid: 'Paid',
    overdue: 'Overdue',
    pending: 'Pending',
    sendReminder: 'Send Reminder',
    
    // Payments
    paymentManagement: 'Payment Management',
    unpaidInvoices: 'unpaid invoices',
    cash: 'Cash',
    payDirectly: 'Pay directly to cashier',
    paymentMethods: 'Payment Methods',
    paymentActions: 'Payment Actions',
    confirmCashPayment: 'Confirm Cash Payment',
    invoice: 'Invoice',
    paymentAmount: 'Payment Amount',
    confirmPayment: 'Confirm Payment',
    
    // Settings
    mikrotikConfig: 'Mikrotik Configuration',
    wablastConfig: 'Wablast Configuration',
    paymentGatewayConfig: 'Payment Gateway Configuration',
    host: 'Host / IP Address',
    port: 'Port',
    username: 'Username',
    password: 'Password',
    wablastToken: 'Wablast Token',
    getTokenFrom: 'Get token from',
    apiKey: 'API Key',
    merchantCode: 'Merchant Code',
    getCredentials: 'Get credentials from',
    saveConfiguration: 'Save Configuration',
    
    // Branches
    branchManagement: 'Branch Management',
    addBranch: 'Add Branch',
    branchName: 'Branch Name',
    branchCode: 'Branch Code',
    branchAddress: 'Branch Address',
    branchPhone: 'Branch Phone',
    active: 'Active',
    inactive: 'Inactive',
    
    // Financial Reports
    financialReports: 'Financial Reports',
    grossRevenue: 'Gross Revenue',
    adjustedRevenue: 'Adjusted Revenue',
    netRevenue: 'Net Revenue',
    bhp: 'BHP Telecommunication',
    uso: 'Universal Service Obligation',
    ppn: 'VAT (PPN)',
    taxConfiguration: 'Tax Configuration',
    monthly: 'Monthly',
    yearly: 'Yearly',
    
    // Common
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    total: 'Total',
    needHelp: 'Need Help?',
    contactSupport: 'Contact support',
    getSupport: 'Get Support',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    confirmDelete: 'Are you sure you want to delete this?',
    companyName: 'PT. Pusaka Kreasi Mandiri',
    brandName: 'ISP Billing',
    
    // Messages
    customerAdded: 'Customer added successfully',
    customerUpdated: 'Customer updated successfully',
    customerDeleted: 'Customer deleted successfully',
    paymentRecorded: 'Payment recorded successfully',
    invoiceGenerated: 'Invoice generated successfully',
    configSaved: 'Configuration saved successfully',
    branchAdded: 'Branch added successfully',
    
    // Additional translations
    refresh: 'Refresh',
    owner: 'Owner',
    registrationDate: 'Registration Date',
    packagePlan: 'Package',
    cost: 'Cost',
    allBranches: 'All Branches',
    ipAddress: 'IP Address',
    paymentStatus: 'Status',
    paidStatus: 'Paid',
    unpaidStatus: 'Unpaid',
    overdueStatus: 'Overdue',
    viewDetails: 'View',
    print: 'Print',
    changeStatus: 'Change Status',
    editDates: 'Edit Dates',
    showEntries: 'Show entries',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    entries: 'entries',
    previous: 'Previous',
    next: 'Next',
    all: 'All',
    unpaid: 'Unpaid',
    paymentSuccess: 'Payment successfully recorded',
    paymentFailed: 'Failed to process payment',
    cashPayment: 'Cash Payment',
    confirmCash: 'Confirm Cash Payment',
    paymentAmountLabel: 'Payment Amount (Rp)',
    confirm: 'Confirm',
    mikrotikSaved: 'Mikrotik configuration saved successfully',
    wablastSaved: 'Wablast configuration saved successfully',
    paymentGatewaySaved: 'Payment gateway configuration saved successfully',
    whatsappConfig: 'WhatsApp Configuration',
    notificationSettings: 'Customer WhatsApp notification configuration',
    expenses: 'Expenses',
    addExpense: 'Add Expense',
    newExpense: 'Add New Expense',
    paymentMethod: 'Payment Method',
    addCategory: 'Add Category',
    newCategory: 'Add New Category',
    expenseAdded: 'Expense added successfully',
    categoryAdded: 'Category added successfully',
  },
  id: {
    // Navigation
    dashboard: 'Dashboard',
    customers: 'Pelanggan',
    invoices: 'Tagihan',
    payments: 'Pembayaran',
    settings: 'Pengaturan',
    branches: 'Cabang',
    servicePlans: 'Paket Layanan',
    expenses: 'Pengeluaran',
    reports: 'Laporan Keuangan',
    whatsapp: 'WhatsApp',
    companySettings: 'Info Perusahaan',
    users: 'Users',
    owners: 'Pemilik/Owner',
    systemTools: 'Tools Sistem',
    
    // Dashboard
    good: 'Baik',
    warning: 'Peringatan',
    critical: 'Kritis',
    other: 'Lainnya',
    totalRevenue: 'Total Pendapatan',
    fromLastMonth: 'dari bulan lalu',
    latestCustomers: 'Pelanggan Terbaru',
    viewAll: 'Lihat Semua',
    status: 'Status',
    name: 'Nama',
    accountNo: 'No. Akun',
    plan: 'Paket',
    monthlyFee: 'Biaya Bulanan',
    connection: 'Koneksi',
    online: 'Online',
    offline: 'Offline',
    
    // Customers
    customerManagement: 'Manajemen Pelanggan',
    addCustomer: 'Tambah Pelanggan',
    searchCustomers: 'Cari pelanggan...',
    addNewCustomer: 'Tambah Pelanggan Baru',
    customer: 'Pelanggan',
    actions: 'Aksi',
    email: 'Email',
    phone: 'No. Telepon',
    address: 'Alamat',
    servicePlan: 'Paket Layanan',
    mikrotikUser: 'Username Mikrotik',
    mikrotikPassword: 'Password Mikrotik',
    cancel: 'Batal',
    save: 'Simpan',
    edit: 'Edit',
    delete: 'Hapus',
    activate: 'Aktifkan',
    isolate: 'Isolir',
    
    // Invoices
    invoiceManagement: 'Manajemen Tagihan',
    totalInvoices: 'total tagihan',
    generateMonthlyInvoices: 'Generate Tagihan Bulanan',
    invoiceNumber: 'No. Invoice',
    amount: 'Jumlah',
    dueDate: 'Jatuh Tempo',
    paid: 'Lunas',
    overdue: 'Jatuh Tempo',
    pending: 'Pending',
    sendReminder: 'Kirim Reminder',
    
    // Payments
    paymentManagement: 'Manajemen Pembayaran',
    unpaidInvoices: 'tagihan belum dibayar',
    cash: 'Tunai',
    payDirectly: 'Bayar langsung ke kasir',
    paymentMethods: 'Metode Pembayaran',
    paymentActions: 'Aksi Pembayaran',
    confirmCashPayment: 'Konfirmasi Pembayaran Tunai',
    invoice: 'Invoice',
    paymentAmount: 'Jumlah Pembayaran',
    confirmPayment: 'Konfirmasi Pembayaran',
    
    // Settings
    mikrotikConfig: 'Konfigurasi Mikrotik',
    wablastConfig: 'Konfigurasi Wablast',
    paymentGatewayConfig: 'Konfigurasi Payment Gateway',
    host: 'Host / IP Address',
    port: 'Port',
    username: 'Username',
    password: 'Password',
    wablastToken: 'Token Wablast',
    getTokenFrom: 'Dapatkan token dari',
    apiKey: 'API Key',
    merchantCode: 'Kode Merchant',
    getCredentials: 'Dapatkan credentials dari',
    saveConfiguration: 'Simpan Konfigurasi',
    
    // Branches
    branchManagement: 'Manajemen Cabang',
    addBranch: 'Tambah Cabang',
    branchName: 'Nama Cabang',
    branchCode: 'Kode Cabang',
    branchAddress: 'Alamat Cabang',
    branchPhone: 'Telepon Cabang',
    active: 'Aktif',
    inactive: 'Tidak Aktif',
    
    // Financial Reports
    financialReports: 'Laporan Keuangan',
    grossRevenue: 'Pendapatan Kotor',
    adjustedRevenue: 'Pendapatan Disesuaikan',
    netRevenue: 'Pendapatan Bersih',
    bhp: 'BHP Telekomunikasi',
    uso: 'USO (Universal Service Obligation)',
    ppn: 'PPN (Pajak Pertambahan Nilai)',
    taxConfiguration: 'Konfigurasi Pajak',
    monthly: 'Bulanan',
    yearly: 'Tahunan',
    
    // Common
    search: 'Cari',
    filter: 'Filter',
    export: 'Ekspor',
    import: 'Impor',
    total: 'Total',
    needHelp: 'Butuh Bantuan?',
    contactSupport: 'Hubungi support',
    getSupport: 'Dapatkan Bantuan',
    loading: 'Memuat...',
    success: 'Berhasil',
    error: 'Error',
    confirmDelete: 'Yakin ingin menghapus ini?',
    companyName: 'PT. Pusaka Kreasi Mandiri',
    brandName: 'ISP Billing',
    
    // Messages
    customerAdded: 'Pelanggan berhasil ditambahkan',
    customerUpdated: 'Pelanggan berhasil diupdate',
    customerDeleted: 'Pelanggan berhasil dihapus',
    paymentRecorded: 'Pembayaran berhasil dicatat',
    invoiceGenerated: 'Invoice berhasil digenerate',
    configSaved: 'Konfigurasi berhasil disimpan',
    branchAdded: 'Cabang berhasil ditambahkan',
    
    // Additional translations
    refresh: 'Refresh',
    owner: 'Pemilik',
    registrationDate: 'Tgl Registrasi',
    packagePlan: 'Paket',
    cost: 'Biaya',
    allBranches: 'Semua Cabang',
    ipAddress: 'Alamat IP',
    paymentStatus: 'Status',
    paidStatus: 'Lunas',
    unpaidStatus: 'Belum Lunas',
    overdueStatus: 'Terlambat',
    viewDetails: 'Lihat',
    print: 'Cetak',
    changeStatus: 'Ubah Status',
    editDates: 'Edit Tanggal',
    showEntries: 'Tampilkan entri',
    showing: 'Menampilkan',
    to: 'sampai',
    of: 'dari',
    entries: 'entri',
    previous: 'Sebelumnya',
    next: 'Selanjutnya',
    all: 'Semua',
    unpaid: 'Belum Dibayar',
    paymentSuccess: 'Pembayaran berhasil dicatat',
    paymentFailed: 'Gagal memproses pembayaran',
    cashPayment: 'Pembayaran Tunai',
    confirmCash: 'Konfirmasi Pembayaran Tunai',
    paymentAmountLabel: 'Jumlah Pembayaran (Rp)',
    confirm: 'Konfirmasi',
    mikrotikSaved: 'Konfigurasi Mikrotik berhasil disimpan',
    wablastSaved: 'Konfigurasi Wablast berhasil disimpan',
    paymentGatewaySaved: 'Konfigurasi payment gateway berhasil disimpan',
    whatsappConfig: 'Konfigurasi WhatsApp',
    notificationSettings: 'Konfigurasi notifikasi WhatsApp untuk pelanggan',
    expenses: 'Pengeluaran',
    addExpense: 'Tambah Pengeluaran',
    newExpense: 'Tambah Pengeluaran Baru',
    paymentMethod: 'Metode Pembayaran',
    addCategory: 'Tambah Kategori',
    newCategory: 'Tambah Kategori Baru',
    expenseAdded: 'Pengeluaran berhasil ditambahkan',
    categoryAdded: 'Kategori berhasil ditambahkan',
  }
};